import {
  FormControlLabel,
  styled,
  Checkbox as MuiCheckbox,
  CheckboxProps as MuiCheckboxProps,
  FormControlLabelProps,
  FormControlLabelSlotsAndSlotProps,
} from '@mui/material';
import React, { useMemo } from 'react';

export interface LabelProps extends FormControlLabelSlotsAndSlotProps {
  label: FormControlLabelProps['label'];
  labelId?: string;
  labelPlacement?: FormControlLabelProps['labelPlacement'];
  disableTypography?: FormControlLabelProps['disableTypography'];
}

export interface CheckboxProps extends MuiCheckboxProps, LabelProps {
  checkboxId?: string;
}

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  color: theme.palette.grey[900],
}));

const StyledCheckbox = styled(MuiCheckbox)(({ theme }) => ({
  color: theme.palette.primary.main,
}));

export const Checkbox = ({
  labelId,
  checkboxId,
  label,
  labelPlacement,
  disableTypography,
  slots,
  slotProps,
  ...restProps
}: CheckboxProps) => {
  const inputId = useMemo(
    () => checkboxId ?? `checkbox__${label}`.replaceAll(' ', '-').toLowerCase(),
    [checkboxId, label],
  );

  const id = useMemo(
    () => labelId ?? `checkbox__label-${label}`.replaceAll(' ', '-').toLowerCase(),
    [labelId, label],
  );

  return (
    <StyledFormControlLabel
      id={id}
      key={id}
      label={label}
      labelPlacement={labelPlacement}
      disableTypography={disableTypography}
      slots={slots}
      slotProps={slotProps}
      checked={restProps.checked}
      disabled={restProps.disabled}
      name={restProps.name}
      required={restProps.required}
      control={
        <StyledCheckbox
          {...restProps}
          inputProps={{
            ...restProps.inputProps,
            'aria-checked': restProps.checked,
            'aria-labelledby': id,
            id: inputId,
          }}
        />
      }
    />
  );
};
